import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Message from '../Message/Message'
import { paginateMessages } from '../../../../store/actions/chat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './MessageBox.scss'

const MessageBox = ({ chat, onOptionClick }) => {

    const dispatch = useDispatch();

    const user = useSelector(state => state.authReducer.user);
    const scrollBottom = useSelector(state => state.chatReducer.scrollBottom);
    const senderTyping = useSelector(state => state.chatReducer.senderTyping);
    const [loading, setLoading] = useState(false);
    const [scrollUp, setScrollUp] = useState(0);
    console.log("chat---->", chat)

    const msgBox = useRef();

    const scrollManual = (value) => {
        msgBox.current.scrollTop = value
    };

    const handleInfiniteScroll = (e) => {
        if (e.target.scrollTop === 0) {

            setLoading(true);
            const pagination = chat.Pagination;
            const page = typeof pagination === 'undefined' ? 1 : pagination.page;

            dispatch(paginateMessages(chat.id, parseInt(page) + 1))
                .then(res => {
                    if (res) {
                        setScrollUp(scrollUp + 1)
                    }
                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                })
        }
    };

    const handleOptionClick = (value) => {
    // Simulate the user selecting the option and sending it back to bot

    // You should dispatch/send this value to your bot handler here
    // Example: dispatch(sendBotMessage(chat.id, value))
};


    useEffect(() => {
        setTimeout(() => {
            scrollManual(Math.ceil(msgBox.current.scrollHeight * 0.10))
        }, 100)
    }, [scrollUp]);

    useEffect(() => {
        if (senderTyping.typing && msgBox.current.scrollTop > msgBox.current.scrollHeight * 0.30) {
            setTimeout(() => {
                scrollManual(msgBox.current.scrollHeight)
            }, 100)
        }
    }, [senderTyping]);

    useEffect(() => {
        if (!senderTyping.typing) {
            setTimeout(() => {
                scrollManual(msgBox.current.scrollHeight)
            }, 100)
        }
    }, [scrollBottom]);

    return (
        <div onScroll={handleInfiniteScroll} id='msg-box' ref={msgBox}>
            {
                loading
                    ? <p className='loader m-0'><FontAwesomeIcon icon='spinner' className='fa-spin' /></p>
                    : null
            }
            {
                chat.Messages && chat.Messages.map((message, index) => {
                    if (message.type === 'options') {
                        return (
                            <div className="bot-options message" key={message.id || index}>
                                <div className="bot-options-message other-person">
                                    {message.User.firstName}
                                    <p>{message.message}</p>
                                    </div>
                                <div className="bot-options-buttons">
                                    {Array.isArray(message.options) && message.options.map((opt, i) => (
                                        <button
                                            key={i}
                                            className="bot-option-button"
                                            onClick={() => onOptionClick(opt.label)}
                                        >
                                            {opt.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                        );
                    }

                    // Fallback to regular message
                    return <Message
                        user={user}
                        chat={chat}
                        message={message}
                        index={index}
                        key={message.id}
                    />
                })

            }
            {
                senderTyping.typing && senderTyping.chatId === chat.id
                ? <div className='message mt-5p'>
                    <div className='other-person typing-indicator'>
                        <span className='typer-name'>{senderTyping.fromUser.firstName} {senderTyping.fromUser.lastName}</span>
                        <div className='typing-dots'>
                            <span className='dot'></span>
                            <span className='dot'></span>
                            <span className='dot'></span>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    )
};

export default MessageBox